import { render, staticRenderFns } from "./CategoriaTarifaCadastro.vue?vue&type=template&id=ce10dcfc&scoped=true&"
import script from "./CategoriaTarifaCadastro.vue?vue&type=script&lang=js&"
export * from "./CategoriaTarifaCadastro.vue?vue&type=script&lang=js&"
import style0 from "./CategoriaTarifaCadastro.vue?vue&type=style&index=0&id=ce10dcfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce10dcfc",
  null
  
)

export default component.exports